import BonusProvider from '../../modules/Bonus/components/BonusProvider';
import MobileFirebaseProvider from './MobileFirebaseProvider/MobileFirebaseProvider';
import ScrollProvider from '../../providers/ScrollProvider/ScrollProvider';
import NotificationsProvider from '../../modules/Notifications/provider/NotificationsProvider';
import Zendesk from '../../modules/Zendesk/Zendesk';
import HotjarProvider from '../../providers/HotjarProvider';
import React from 'react';
import AnimationProvider from '../../modules/Animation/AnimationProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import ExponeaProvider from '../../modules/Exponea/ExponeaProvider';
import { useSelector } from 'react-redux';
import { getLocationPlatformSelector } from '../../modules/Location/locationSelectors';
import classNames from 'classnames';
import { LOCATION_PLATFORM } from '../../modules/Location/locationConstants';
import useMarginLevelWatch from '../../modules/LiteTrade/hooks/useMarginLevelWatch';
import GoogleTagManagerProvider from '../../modules/GoogleTagManager/GoogleTagManagerProvider';
import UserStateInformationProvider from '../../modules/UserStateInformation/UserStateInformationProvider';
import RequestFeedbackProvider from '../../modules/RequestFeedback/RequestFeedbackProvider';
import TelegramProvider from "../../providers/TelegramProvider/TelegramProvider";
import TutorialsProvider from '../../modules/Tutorials/TutorialsProvider';
import ColorThemeProvider from '../../modules/ColorTheme/ColorThemeProvider';
import AcademyProvider from '../../modules/Academy/AcademyProvider';

interface IMobileProvidersProps {
    children: JSX.Element | JSX.Element[];
}

function MobileProviders(props: IMobileProvidersProps) {
    const { children } = props;
    const platform = useSelector(getLocationPlatformSelector);
    const isDesktop = platform === LOCATION_PLATFORM.DESKTOP;

    useMarginLevelWatch();

    return <>
        <GoogleOAuthProvider clientId='807450067447-ur0cakra27e9qkvpeaasicrkam85mu2d.apps.googleusercontent.com'>
            <MobileFirebaseProvider>
                <NotificationsProvider
                    limit={3}
                    position={'top-center'}
                    draggableDirection='y'
                    draggablePercent={20}
                    closeOnClick={false}
                    autoClose={2000}
                    className={classNames({ 'desktop-top-right-notifications': isDesktop })}
                />
                <ExponeaProvider/>
                <HotjarProvider/>
                <ScrollProvider>
                    <BonusProvider>
                        <Zendesk>
                            <TelegramProvider>
                                {children}
                            </TelegramProvider>
                        </Zendesk>
                    </BonusProvider>
                </ScrollProvider>
                <AnimationProvider/>
                <GoogleTagManagerProvider/>
                <UserStateInformationProvider/>
                <RequestFeedbackProvider/>

                {/*TODO CFD-10290 Удалить после интеграции академии*/}
                <TutorialsProvider/>

                <ColorThemeProvider/>
                <AcademyProvider/>
            </MobileFirebaseProvider>
        </GoogleOAuthProvider>
    </>;
}

export default MobileProviders;
